// import React, { useState } from 'react';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     message: '',
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Handle form submission
//     console.log('Form submitted:', formData);
//     alert('Thank you for your inquiry! We will contact you soon.');
//     setFormData({ firstName: '', lastName: '', email: '', phone: '', message: '' });
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   return (
//     <div className="contact">
//       {/* Hero Section */}
//       <section
//         className="relative h-[70vh] flex items-center justify-center overflow-hidden"
//         style={{
//           backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?w=1920&q=80')`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundAttachment: 'fixed',
//         }}
//       >
//         <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/50"></div>
//         <div className="relative z-10 text-center px-4">
//           <div className="mb-6">
//             <span className="inline-block w-20 h-[2px] bg-luxury-accent mb-4"></span>
//           </div>
//           <h1 className="font-serif text-6xl lg:text-8xl font-bold text-white mb-6 tracking-tight">
//             Contact
//           </h1>
//           <p className="text-xl lg:text-2xl text-white/90 max-w-2xl mx-auto font-light tracking-wide">
//             Let's Begin Your Journey to Extraordinary Living
//           </p>
//         </div>
//       </section>

//       {/* Contact Information Cards */}
//       <section className="py-20 bg-luxury-white relative">
//         <div className="absolute inset-0 bg-gradient-to-b from-luxury-bg/30 to-transparent"></div>
//         <div className="container mx-auto px-4 lg:px-8 relative z-10">
//           <div className="text-center mb-16">
//             <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//               Contact Info
//             </span>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//               We're Always Here to Assist
//             </h2>
//             <p className="text-lg text-luxury-primary max-w-3xl mx-auto leading-relaxed">
//               Whether you have questions, need support, or want to schedule an appointment, our dedicated team is ready to help you find your perfect home.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
//             {/* Address Card */}
//             <div className="group bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 border border-luxury-secondary/10 hover:border-luxury-accent/30 hover:-translate-y-2">
//               <div className="w-16 h-16 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
//                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Address</h3>
//               <p className="text-luxury-primary leading-relaxed">
//                 78, Meridian Corporate Plaza<br />
//                 Horizon Street, Block-C<br />
//                 Greenfield City, Hyderabad – 500045
//               </p>
//             </div>

//             {/* Phone Card */}
//             <div className="group bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 border border-luxury-secondary/10 hover:border-luxury-accent/30 hover:-translate-y-2">
//               <div className="w-16 h-16 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
//                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Phone</h3>
//               <div className="space-y-2">
//                 <a href="tel:+911234567890" className="block text-luxury-primary hover:text-luxury-accent transition-colors font-medium">
//                   +91-1234567890
//                 </a>
//                 <a href="tel:+919876543210" className="block text-luxury-primary hover:text-luxury-accent transition-colors font-medium">
//                   +91-9876543210
//                 </a>
//               </div>
//             </div>

//             {/* Email Card */}
//             <div className="group bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 border border-luxury-secondary/10 hover:border-luxury-accent/30 hover:-translate-y-2">
//               <div className="w-16 h-16 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
//                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Email</h3>
//               <a href="mailto:preetham.miriyala@gmail.com" className="text-luxury-primary hover:text-luxury-accent transition-colors block break-words font-medium">
//                 preetham.miriyala@gmail.com
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section className="py-20 lg:py-32 bg-gradient-to-br from-luxury-bg via-luxury-white to-luxury-bg">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-5xl mx-auto">
//             <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
//               <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
//                 {/* Sidebar */}
//                 <div className="lg:col-span-2 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark p-12 text-white relative overflow-hidden">
//                   <div className="absolute top-0 right-0 w-64 h-64 bg-luxury-accent/10 rounded-full -mr-32 -mt-32"></div>
//                   <div className="absolute bottom-0 left-0 w-48 h-48 bg-luxury-accent/10 rounded-full -ml-24 -mb-24"></div>
//                   <div className="relative z-10">
//                     <h3 className="font-serif text-3xl font-bold mb-6">Get in Touch</h3>
//                     <p className="text-white/80 leading-relaxed mb-12">
//                       Share your details and our team will reach out to you shortly to discuss your requirements.
//                     </p>
                    
//                     <div className="space-y-6">
//                       <div className="flex items-start gap-4">
//                         <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
//                           <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                           </svg>
//                         </div>
//                         <div>
//                           <p className="text-white/90">Quick Response Time</p>
//                         </div>
//                       </div>
                      
//                       <div className="flex items-start gap-4">
//                         <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
//                           <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                           </svg>
//                         </div>
//                         <div>
//                           <p className="text-white/90">Professional Consultation</p>
//                         </div>
//                       </div>
                      
//                       <div className="flex items-start gap-4">
//                         <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
//                           <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                           </svg>
//                         </div>
//                         <div>
//                           <p className="text-white/90">Personalized Solutions</p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Form */}
//                 <div className="lg:col-span-3 p-12">
//                   <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-8">Send Us a Message</h3>
//                   <form onSubmit={handleSubmit} className="space-y-6">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                       <div>
//                         <label htmlFor="firstName" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
//                           First Name
//                         </label>
//                         <input
//                           type="text"
//                           id="firstName"
//                           name="firstName"
//                           value={formData.firstName}
//                           onChange={handleChange}
//                           required
//                           className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
//                           placeholder="Enter First Name"
//                         />
//                       </div>

//                       <div>
//                         <label htmlFor="lastName" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
//                           Last Name
//                         </label>
//                         <input
//                           type="text"
//                           id="lastName"
//                           name="lastName"
//                           value={formData.lastName}
//                           onChange={handleChange}
//                           required
//                           className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
//                           placeholder="Enter Last Name"
//                         />
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                       <div>
//                         <label htmlFor="email" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
//                           Email
//                         </label>
//                         <input
//                           type="email"
//                           id="email"
//                           name="email"
//                           value={formData.email}
//                           onChange={handleChange}
//                           required
//                           className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
//                           placeholder="Enter your Email"
//                         />
//                       </div>

//                       <div>
//                         <label htmlFor="phone" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
//                           Phone
//                         </label>
//                         <input
//                           type="tel"
//                           id="phone"
//                           name="phone"
//                           value={formData.phone}
//                           onChange={handleChange}
//                           required
//                           className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
//                           placeholder="Enter Phone Number"
//                         />
//                       </div>
//                     </div>

//                     <div>
//                       <label htmlFor="message" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
//                         Message
//                       </label>
//                       <textarea
//                         id="message"
//                         name="message"
//                         value={formData.message}
//                         onChange={handleChange}
//                         required
//                         rows="5"
//                         className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none resize-none"
//                         placeholder="Tell us about your requirements..."
//                       />
//                     </div>

//                     <button
//                       type="submit"
//                       className="w-full px-8 py-4 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white font-semibold uppercase tracking-wider rounded-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden group"
//                     >
//                       <span className="relative z-10">Send Message</span>
//                       <div className="absolute inset-0 bg-gradient-to-r from-luxury-primary to-luxury-accent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
//                     </button>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Map Section */}
//       <section className="h-[500px] relative">
//         <iframe
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243647.3160407499!2d78.24323209999999!3d17.412608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1706624000000!5m2!1sen!2sin"
//           width="100%"
//           height="100%"
//           style={{ border: 0 }}
//           allowFullScreen=""
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//           title="Vedamsa Infrastructure Location"
//           className="grayscale hover:grayscale-0 transition-all duration-500"
//         ></iframe>
        
//         {/* Map Overlay */}
//         <div className="absolute bottom-8 left-8 bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-2xl max-w-md">
//           <h4 className="font-serif text-2xl font-bold text-luxury-dark mb-2">Visit Our Office</h4>
//           <p className="text-luxury-primary mb-4">
//             78, Meridian Corporate Plaza, Horizon Street, Block-C<br />
//             Greenfield City, Hyderabad – 500045
//           </p>
//           <a
//             href="https://maps.google.com/?q=78+Meridian+Corporate+Plaza+Hyderabad"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="inline-flex items-center gap-2 text-luxury-accent hover:text-luxury-primary font-semibold transition-colors"
//           >
//             Get Directions
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white">
//         <div className="container mx-auto px-4 text-center">
//           <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
//             Ready to Find Your Dream Home?
//           </h2>
//           <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
//             Schedule a consultation with our team and let us help you discover the perfect property.
//           </p>
//           <div className="flex flex-col sm:flex-row gap-6 justify-center">
//             <a
//               href="tel:+911234567890"
//               className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-luxury-accent text-white font-semibold uppercase tracking-wider rounded-lg hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//             >
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//               </svg>
//               Call Us Now
//             </a>
//             <a
//               href="mailto:preetham.miriyala@gmail.com"
//               className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold uppercase tracking-wider rounded-lg border-2 border-white/30 hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//             >
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//               </svg>
//               Email Us
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Contact;


import React, { useState, useRef, useEffect } from 'react';

const RevealContent = ({ children, className = "", delay = 0 }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
      } ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will contact you soon.');
    setFormData({ firstName: '', lastName: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section
        className="relative h-[70vh] flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?w=1920&q=80')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/50"></div>
        <RevealContent className="relative z-10 text-center px-4">
          <div className="mb-6">
            <span className="inline-block w-20 h-[2px] bg-luxury-accent mb-4"></span>
          </div>
          <h1 className="font-serif text-6xl lg:text-8xl font-bold text-white mb-6 tracking-tight">
            Contact
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 max-w-2xl mx-auto font-light tracking-wide">
            Let's Begin Your Journey to Extraordinary Living
          </p>
        </RevealContent>
      </section>

      {/* Contact Information Cards */}
      <section className="py-20 bg-luxury-white relative">
        <div className="absolute inset-0 bg-gradient-to-b from-luxury-bg/30 to-transparent"></div>
        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <RevealContent className="text-center mb-16">
            <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
              Contact Info
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
              We're Always Here to Assist
            </h2>
            <p className="text-lg text-luxury-primary max-w-3xl mx-auto leading-relaxed">
              Whether you have questions, need support, or want to schedule an appointment, our dedicated team is ready to help you find your perfect home.
            </p>
          </RevealContent>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* Address Card */}
            <RevealContent delay={100}>
              <div className="group bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 border border-luxury-secondary/10 hover:border-luxury-accent/30 hover:-translate-y-2 h-full">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Address</h3>
                <p className="text-luxury-primary leading-relaxed">
                  78, Meridian Corporate Plaza<br />
                  Horizon Street, Block-C<br />
                  Greenfield City, Hyderabad – 500045
                </p>
              </div>
            </RevealContent>

            {/* Phone Card */}
            <RevealContent delay={200}>
              <div className="group bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 border border-luxury-secondary/10 hover:border-luxury-accent/30 hover:-translate-y-2 h-full">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Phone</h3>
                <div className="space-y-2">
                  <a href="tel:+919584646464" className="block text-luxury-primary hover:text-luxury-accent transition-colors font-medium">
                    +91 9584646464
                  </a>
                  {/* <a href="tel:+919876543210" className="block text-luxury-primary hover:text-luxury-accent transition-colors font-medium">
                    +91-9876543210
                  </a> */}
                </div>
              </div>
            </RevealContent>

            {/* Email Card */}
            <RevealContent delay={300}>
              <div className="group bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 border border-luxury-secondary/10 hover:border-luxury-accent/30 hover:-translate-y-2 h-full">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Email</h3>
                <a href="mailto:preetham.miriyala@gmail.com" className="text-luxury-primary hover:text-luxury-accent transition-colors block break-words font-medium">
                  preetham.miriyala@gmail.com
                </a>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 lg:py-32 bg-gradient-to-br from-luxury-bg via-luxury-white to-luxury-bg">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <RevealContent>
              <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
                  {/* Sidebar */}
                  <div className="lg:col-span-2 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark p-12 text-white relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-luxury-accent/10 rounded-full -mr-32 -mt-32"></div>
                    <div className="absolute bottom-0 left-0 w-48 h-48 bg-luxury-accent/10 rounded-full -ml-24 -mb-24"></div>
                    <div className="relative z-10">
                      <h3 className="font-serif text-3xl font-bold mb-6">Get in Touch</h3>
                      <p className="text-white/80 leading-relaxed mb-12">
                        Share your details and our team will reach out to you shortly to discuss your requirements.
                      </p>
                      
                      <div className="space-y-6">
                        <div className="flex items-start gap-4">
                          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                            <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-white/90">Quick Response Time</p>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-4">
                          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                            <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-white/90">Professional Consultation</p>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-4">
                          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                            <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-white/90">Personalized Solutions</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Form */}
                  <div className="lg:col-span-3 p-12">
                    <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-8">Send Us a Message</h3>
                    <form onSubmit={handleSubmit} className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="firstName" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
                            First Name
                          </label>
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
                            placeholder="Enter First Name"
                          />
                        </div>

                        <div>
                          <label htmlFor="lastName" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
                            Last Name
                          </label>
                          <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
                            placeholder="Enter Last Name"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="email" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
                            Email
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
                            placeholder="Enter your Email"
                          />
                        </div>

                        <div>
                          <label htmlFor="phone" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
                            Phone
                          </label>
                          <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none"
                            placeholder="Enter Phone Number"
                          />
                        </div>
                      </div>

                      <div>
                        <label htmlFor="message" className="block text-sm font-semibold text-luxury-dark mb-2 uppercase tracking-wider">
                          Message
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                          rows="5"
                          className="w-full px-4 py-3 bg-luxury-bg/50 border-b-2 border-luxury-secondary/30 focus:border-luxury-accent focus:bg-white transition-all duration-300 outline-none resize-none"
                          placeholder="Tell us about your requirements..."
                        />
                      </div>

                      <button
                        type="submit"
                        className="w-full px-8 py-4 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white font-semibold uppercase tracking-wider rounded-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden group"
                      >
                        <span className="relative z-10">Send Message</span>
                        <div className="absolute inset-0 bg-gradient-to-r from-luxury-primary to-luxury-accent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="h-[500px] relative">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243647.3160407499!2d78.24323209999999!3d17.412608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1706624000000!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Vedamsa Infrastructure Location"
          className="grayscale hover:grayscale-0 transition-all duration-500"
        ></iframe>
        
        {/* Map Overlay */}
        <RevealContent delay={200} className="absolute bottom-8 left-8 max-w-md">
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-2xl">
            <h4 className="font-serif text-2xl font-bold text-luxury-dark mb-2">Visit Our Office</h4>
            <p className="text-luxury-primary mb-4">
              78, Meridian Corporate Plaza, Horizon Street, Block-C<br />
              Greenfield City, Hyderabad – 500045
            </p>
            <a
              href="https://maps.google.com/?q=78+Meridian+Corporate+Plaza+Hyderabad"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-luxury-accent hover:text-luxury-primary font-semibold transition-colors"
            >
              Get Directions
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </a>
          </div>
        </RevealContent>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white">
        <div className="container mx-auto px-4 text-center">
          <RevealContent>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
              Ready to Find Your Dream Home?
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
              Schedule a consultation with our team and let us help you discover the perfect property.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a
                href="tel:+911234567890"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-luxury-accent text-white font-semibold uppercase tracking-wider rounded-lg hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                Call Us Now
              </a>
              <a
                href="mailto:preetham.miriyala@gmail.com"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold uppercase tracking-wider rounded-lg border-2 border-white/30 hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Email Us
              </a>
            </div>
          </RevealContent>
        </div>
      </section>
    </div>
  );
};

export default Contact;